module.exports = __webpack_public_path__ + "static/slider-3-91ad94c757c770057495c0cceec89508.png";